import { useHistory } from 'react-router-dom';
import * as React from 'react';

import { DialogRoute } from 'bernie-core';
import { Layer } from 'bernie-view';

import { useLocalization } from '@shared-ui/localization-context';

import { UitkDialog, UitkDialogContent, UitkDialogFooter } from 'uitk-react-dialog';

export interface LegalDialogProps {
  dialogName: string;
  linkUrl?: string;
  message?: string;
  text?: string;
}

export const LegalDialog: React.FunctionComponent<LegalDialogProps> = props => {
  const { dialogName, linkUrl, message, text } = props;
  const { formatText } = useLocalization();
  const history = useHistory();

  if (!linkUrl || !message || !text) {
    return null;
  }

  const openLink = () => {
    window.open(linkUrl);
  };

  const closeDialog = () => {
    history.goBack();
  };

  return (
    <DialogRoute id={dialogName}>
      <Layer id="results-header">
        <UitkDialog>
          <UitkDialogContent>{message}</UitkDialogContent>
          <UitkDialogFooter
            buttonOne={{
              onClick: openLink,
              text,
              type: 'tertiary',
            }}
            buttonTwo={{
              onClick: closeDialog,
              text: formatText('close'),
              type: 'tertiary',
            }}
          />
        </UitkDialog>
      </Layer>
    </DialogRoute>
  );
};
LegalDialog.displayName = 'LegalDialog';
